import React, { FC, ReactFragment } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
interface ConfirmationBoxProps {
    open?: boolean;
    title?: string | ReactFragment;
    description?: string | ReactFragment;
    showDescription?: boolean;
    agreeBtnText?: string;
    cancelBtnText?: string;
    onlyCloseBtn?: boolean;
    handleSubmit?: () => void;
    handleClose?: () => void;
}

const ConfirmationBox: FC<ConfirmationBoxProps> = ({
    open = true,
    title = 'Are you Sure?',
    description = "This action can't be undone.",
    showDescription = true,
    agreeBtnText = 'Confirm',
    cancelBtnText = 'Cancel',
    handleSubmit = () => { },
    handleClose = () => { },
}) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    /*eslint-disable eqeqeq*/
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullScreen={fullScreen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <React.Fragment>
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                {showDescription ? 
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {description}
                    </DialogContentText>
                </DialogContent>
                : ''}
                <DialogActions>
                    <Button
                        type="button"
                        onClick={handleClose}
                        color="primary"
                    >
                        {cancelBtnText}
                    </Button>
                    <Button
                        type="button"
                        onClick={() =>
                            setTimeout(() => {
                                handleSubmit();
                            }, 500)}
                        color="primary"
                        autoFocus
                    >
                        {agreeBtnText}
                    </Button>
                </DialogActions>
            </React.Fragment>
        </Dialog>
    );
};

export default ConfirmationBox;
